<template>
  <div>
    <span v-for="(segment, ind) in segments" :key="ind">
      <span v-if="ind > 0" class="separator"></span>
      <span
           class="cursor-pointer thick"
           @click="$router.push(segment.link)"
           v-if="segment.link"
      >
        {{segment.label}}
      </span>
      <span class="thick" v-else>{{segment.label}}</span>
    </span>
  </div>
</template>

<style scoped lang="stylus">
  @import '~variables'
  .cursor-pointer
    color $primary
  .separator
    color $faded
    margin-right 3px
  .thick
    font-weight 500
  .separator:before
    content ">>"
</style>

<script>
const squeeze = (unit, withoutLink) => {
  if (withoutLink) {
    return ({ label: unit.label, parent_id: unit.parent_id });
  }
  return ({ label: unit.label, link: unit.link, parent_id: unit.parent_id });
};

export default {
  props: {
    id: String,
    lbl: String,
    withoutLink: {
      type: Boolean,
      default: false,
    },
    lastHasLink: {
      type: Boolean,
      default: false,
    },
  },
  components: { },
  computed: {
    segments() {
      const segs = [];
      if (this.id && (this.id !== 'root')) {
        if (this.id[0] === 'c') {
          segs[0] = squeeze(this.$store.state.cases[this.id], this.withoutLink);
        } else {
          segs[0] = squeeze(this.$store.getters.formatUnit(this.id), this.withoutLink);
        }
      }
      while (segs[0] && segs[0].parent_id && (segs[0].parent_id !== 'root')) {
        segs.unshift(squeeze(
          this.$store.getters.formatUnit(segs[0].parent_id), // cases can't be parent
          this.withoutLink,
        ));
      }
      if (this.lbl) {
        segs.push({ label: this.lbl, link: null });
      }
      if (segs[0] && !this.lastHasLink) {
        segs[segs.length - 1].link = null;
      }
      return segs;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/unit-path.vue